import lojasApi from "@/app/services/lojas";

export default {
  namespaced: true,
  state: {
    loja: {
      id: null,
      nome: "",
      cor_primaria: "teal",
      abreviacao: "",
      ativa: true,
    },
    lojas: [],
    pagination: {},
    total_de_registros: 1,
    search: "",
    loja_atual: null,
  },

  mutations: {
    SET_LOJAS(state, lojas) {
      state.lojas = lojas;
    },

    SET_LOJA(state, loja) {
      state.loja = loja;
    },

    SET_LOJA_ATUAL(state, loja_atual) {
      state.loja_atual = loja_atual;
    },

    ADICIONAR(state, loja) {
      state.lojas.unshift(loja);
    },

    ATUALIZAR(state, loja) {
      let index = state.lojas.findIndex((loja_) => loja_.id == loja.id);
      if (index > -1) {
        state.lojas.splice(index, 1, loja);
      }
    },

    EXCLUIR(state, id) {
      let index = state.lojas.findIndex((loja) => loja.id == id);
      if (index > -1) {
        state.lojas.splice(index, 1);
      }
    },

    UNSET_LOTE(state) {
      state.loja = null;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },

    ZERAR(state) {
      state.loja = {
        id: "",
        nome: "",
        cor_primaria: "teal",
        abreviacao: "",
        ativa: true,
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await lojasApi.listar(parametros);
      commit("SET_LOJAS", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let loja = await lojasApi.abrir(id);
      commit("SET_LOJA", loja);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit, dispatch }, loja) {
      let novo_loja = await lojasApi.salvar(loja);
      commit("ADICIONAR", novo_loja);
      dispatch("listar");
    },

    async atualizar({ commit }, loja) {
      await lojasApi.atualizar(loja);
      commit("ATUALIZAR", loja);
    },

    async excluir({ commit }, id) {
      await lojasApi.excluir(id);
      commit("EXCLUIR", id);
    },
  },
};
